import { getGlobalThis } from '../utils/global-this.js';
import { UniversalMemoryStorage } from './universal-memory-storage.js';
const storeId = 'memory-storage';
export const memoryStorage = getLegacyStore() || UniversalMemoryStorage.getOrCreate(storeId);
export function useMemoryData(id, data) {
    return () => {
        if (!memoryStorage.has(id)) {
            memoryStorage.set(id, data());
        }
        return memoryStorage.get(id);
    };
}
function getLegacyStore() {
    const global = getGlobalThis();
    const legacyStoreId = Symbol.for(storeId);
    let store = global[legacyStoreId];
    if (!store) {
        store = UniversalMemoryStorage.getOrCreate(storeId);
        global[legacyStoreId] = store;
    }
    return store;
}
//# sourceMappingURL=memory-storage.js.map